export default __webpack_public_path__ + "static/media/calendar_example.3d5f92c9.png";